import { IPhoneCallResource } from './ICallChecklist';

export interface IAuditSimilarityColResource {
    readonly block: string;
    readonly type: string;
    readonly question: string;
    readonly itemUuid: string;
    readonly value: number | null;
    readonly auditValue: number | null;
    readonly columnName: string;
    readonly hasHumanReasoning?: boolean;
}

export interface ICallChecklistAuditSimilarityResourceServer {
    phoneCall: IPhoneCallResource;
    similarityScore: number;
    numMetricSum: number;
    numMetricTotal: number;
    auditNumMetricSum: number;
    auditNumMetricTotal: number;
    [key: string]: IAuditSimilarityColResource | IPhoneCallResource | number;
}

export interface IAuditSimilarityColMapped {
    columnName: string;
    data: IAuditSimilarityColResource;
}

export interface ICallChecklistAuditSimilarityResource {
    phoneCall: IPhoneCallResource;
    similarityScore: number;
    numMetricSum: number;
    numMetricTotal: number;
    auditNumMetricSum: number;
    auditNumMetricTotal: number;
    columns: IAuditSimilarityColMapped[];
}

const NON_COLUMN_KEYS = new Set([
    'phoneCall',
    'similarityScore',
    'numMetricSum',
    'numMetricTotal',
    'auditNumMetricSum',
    'auditNumMetricTotal',
]);

export const mapCallChecklistAuditSimilarity = (
    data: ICallChecklistAuditSimilarityResourceServer[]
): ICallChecklistAuditSimilarityResource[] =>
    data.map((item) => {
        const columns: IAuditSimilarityColMapped[] = [];
        for (const key in item) {
            if (!NON_COLUMN_KEYS.has(key)) {
                const value = item[key];
                if (typeof value === 'object' && value !== null && 'block' in value) {
                    columns.push({ columnName: key, data: value as IAuditSimilarityColResource });
                }
            }
        }
        return {
            phoneCall: item.phoneCall,
            similarityScore: item.similarityScore,
            numMetricSum: item.numMetricSum,
            numMetricTotal: item.numMetricTotal,
            auditNumMetricSum: item.auditNumMetricSum,
            auditNumMetricTotal: item.auditNumMetricTotal,
            columns,
        };
    });
